import { asTask } from '@execonline-inc/error-handling';
import { Task } from 'taskarian';
import LearningCollectionEditStore from '..';
import { callApi } from '../../../../../../Appy';
import { findLinkT } from '../../../../../../LinkyLinky';
import { fieldsToValues } from '../../../../../../Resource/FormTemplates/Types';
import { learningDesignResourceDecoder } from '../../../../Decoders';
import { AddingLearningDesign } from '../Types';

export const addLearningDesigns = (
  store: LearningCollectionEditStore,
  state: AddingLearningDesign,
) =>
  Task.succeed({})
    .assign('formOutValues', asTask(fieldsToValues(state.newLearningDesignFormTemplate.fields)))
    .assign('link', findLinkT(state.newLearningDesignFormTemplate.target, store.links))
    .andThen(({ formOutValues, link }) =>
      Task.succeed(link).andThen(callApi(learningDesignResourceDecoder, formOutValues)),
    )
    .fork(store.choosingLearningDesigns, store.buildingWithNewLearningDesign);
